import * as React from 'react';
import { useSelector } from 'react-redux';

import { MultiSelect } from '@cian/ui-kit/select';

import { getCurrentTab } from '../../../selectors/tabs';
import { ETabs } from '../../../types/redux/tabs';
import {
  getListingAgencies,
  getListingRealtors,
  setOfferTypeAgencies,
  setOfferTypeRealtors,
} from '../../../actions/filters';
import { EOfferType } from '../../../repositories/agent-catalog-search/v1/get-realtors';
import { getOfferType } from '../../../selectors/filters';
import { DropdownWrapper } from '../../../components/DropdownWrapper';
import { useAppDispatch } from '../../../hooks/useAppDispatch/useAppDispatch';

const options = [
  {
    value: EOfferType.Flat,
    label: 'Жилая',
  },
  {
    value: EOfferType.Suburban,
    label: 'Загородная',
  },
  {
    value: EOfferType.Commercial,
    label: 'Коммерческая',
  },
];

export function OfferTypeContainer() {
  const dispatch = useAppDispatch();

  const currentTab = useSelector(getCurrentTab);
  const offerType = useSelector(getOfferType);
  const changeOfferType = React.useCallback(
    (offerType: EOfferType[]) => {
      const isRealtorsListing = currentTab === ETabs.Realtors;
      const getListing = isRealtorsListing ? getListingRealtors : getListingAgencies;
      const setOfferType = isRealtorsListing ? setOfferTypeRealtors : setOfferTypeAgencies;
      const correctOfferType = offerType.length > 0 ? offerType : undefined;

      dispatch(getListing(setOfferType, correctOfferType));
    },
    [currentTab, dispatch],
  );

  return (
    <DropdownWrapper>
      <MultiSelect
        placeholder="Любая недвижимость"
        width={230}
        onChange={changeOfferType}
        value={offerType}
        options={options}
      />
    </DropdownWrapper>
  );
}
